import type { SubscriptionStatuses } from './subscriptionTypes';

export const initialSubscriptionStatuses: SubscriptionStatuses = {
  Active: true,
  PendingActive: true,
  PendingInactive: false,
  Inactive: false,
  Discontinued: false,
  Expired: false,
  Draft: false,
  Quotation: false,
};
